export default __webpack_public_path__ + "static/kenan-deniz-597983700117ef819c442dc4a781d6cf.png";